<template>
  <Dialog :title="$t('Reactivar Tarjeta Regalo')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <!-- Mensaje informativo para observar la web de ejemplo  -->
      <div class="container_info_azul">
        {{ $t("La nueva fecha de caducidad de la tarjeta regalo no puede ser menor a la que tiene configurada.") }}
      </div>
      <ValidationObserver ref="validationObserver">
        <v-form ref="form" lazy-validation v-if="tarjeta_regalo" class="pa-1">

          <!-- FECHA CADUCIDAD -->
          <v-row class="ma-0 mt-3">
            <v-col cols="12" class="pa-0">
              <ValidationProvider :rules="{'min_date': $moment().format('YYYY-MM-DD'), required}"
                                  :name="$t('Fecha caducidad').toLowerCase()"
                                  v-slot="{ errors, classes }">
                <div class="control" :class="classes">
                  <DatePicker
                      v-model="tarjeta_regalo.fecha_caducidad"
                      :title="$t('Fecha caducidad')"
                      outlined
                      dense
                      hide_details
                      clearable
                  />
                </div>
                <span class="error--text">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>
          </v-row>
          <!-- FIN FECHA CADUCIDAD -->

        </v-form>
      </ValidationObserver>
    </template>

    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary ml-2">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: "FormTarjetaRegalo",
  props: ['value', 'item'],

  data: () => ({
    tarjeta_regalo: null,
    last_mumeracion: null
  }),

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {

    /**
     * Guarda la tarjeta regalo
     * @returns {Promise<void>}
     */
    async save() {
      const form_valid = await this.$refs.validationObserver.validate()
      if (form_valid && this.tarjeta_regalo.id) {
        try {
          const tarjeta = {...this.tarjeta_regalo}
          tarjeta.is_active = true
          const tarjeta_regalo = await this.$store.dispatch('tarjeta_regalo/save', tarjeta)
	        this.$snotify.success(
		        this.$t("Acción realizada con éxito"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
          this.$emit('on_save', {
            tarjeta_regalo: tarjeta_regalo
          })
        } catch (err) {
	        this.$snotify.error(
		        this.$t("Ha ocurrido un error"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
        }
      }
    },
  },

  mounted() {
    this.tarjeta_regalo = {...this.item }
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
}
</script>
